<template lang="html">
  <div id="doctor-registration" class="row page">
    <div class="col-sm-12">
      <div v-if="loader" class="loader"></div>
      <form @submit.prevent="registretionDoctor" novalidate>
        <p class="vet-icon"><img class="img-responsive" src="../assets/img/icons/vet-icon.svg" alt="User Icon"></p>
        <p class="text-left">
          <span>{{translation.registration.requiredField}}</span>
          <span class="text-danger">{{translation.registration.requiredSymbol}}</span>
          <span>{{translation.registration.areRequired}}</span>
        </p>
        <div class="form-group">
          <div :class="{ requiredField: requiredFirstName }">
            <input type="text" class="form-control" name="doctor-FirstName" id="doctorFirstName" :placeholder="translation.registration.doctorFirstName + translation.registration.requiredSymbol" v-model="response.doctorFirstName">
            <label for="doctor-FirstName">{{translation.registration.doctorFirstName + translation.registration.requiredSymbol}}</label>
          </div>
        </div>
        <div class="form-group">
          <div :class="{ requiredField: requiredLastName }">
            <input type="text" class="form-control" name="doctor-lastName" id="doctorLastName" :placeholder="translation.registration.doctorLastName + translation.registration.requiredSymbol" v-model="response.doctorLastName">
            <label for="doctor-lastName">{{translation.registration.doctorLastName + translation.registration.requiredSymbol}}</label>
          </div>
        </div>
        <div class="form-group">
          <div :class="{ requiredField: requiredRegNumber }">
            <input type="text" class="form-control" name="doctor-regNumber" id="doctorRegNumber" :placeholder="translation.registration.regNumber + translation.registration.requiredSymbol" v-model="response.regNumber">
            <label for="doctor-regNumber">{{translation.registration.regNumber + translation.registration.requiredSymbol}}</label>
          </div>
        </div>
        <div class="form-group">
          <div :class="{ requiredField: requiredClinic }">
            <input type="text" class="form-control" name="doctor-clinic" id="doctorClinic" :placeholder="translation.registration.clinic + translation.registration.requiredSymbol" v-model="response.clinic">
            <label for="doctor-clinic">{{translation.registration.clinic + translation.registration.requiredSymbol}}</label>
          </div>
        </div>
        <div class="form-group">
          <div :class="{ requiredField: requiredEmail }">
            <input type="email" class="form-control"
                 id="clini-registration-email" name="doctor-email" :placeholder="translation.registration.email + translation.registration.requiredSymbol" v-model="response.doctorEmail">
            <label for="doctor-email">{{translation.registration.email + translation.registration.requiredSymbol}}</label>
          </div>
        </div>
        <div class="form-group">
          <div :class="{ requiredField: requiredPassword }">
            <input :type="type" class="form-control" name="doctor-password" id="doctor-registration-password" :placeholder="translation.registration.password + translation.registration.passwordLenth + translation.registration.requiredSymbol" v-model="response.doctorPassword">
            <label for="doctor-password">
              {{translation.registration.password + translation.registration.passwordLenth + translation.registration.requiredSymbol}}
            </label>
            <span class="show-pass" @click="showPassword"><img class="img-responsive" src="../assets/img/icons/eye-password.svg" alt="eye-password.svg"></span>
          </div>
        </div>
        <p v-if="errors.length" class="text-left text-danger">
          <b>{{translation.registration.correct}}:</b>
          <ul class="list-group">
            <li class="text-danger text-left list-group-item list-group-item-light" v-for="error in errors">{{ error }}</li>
          </ul>
        </p>
        <Terms/>
      </form>
    </div>
  </div>
</template>

<script>

import Terms from './terms/Terms.vue';
export default {
  name: 'DoctorRegistration',
  components:{
    Terms
  },
  data(){
    return {
      translation: null,
      loader: false,
      errors: [],
      type: 'password',
      requiredEmail: false,
      requiredFirstName: false,
      requiredLastName: false,
      requiredPassword: false,
      requiredClinic: false,
      requiredRegNumber: false,
      response : {
        doctorEmail: null,
        doctorFirstName: null,
        doctorLastName: null,
        doctorPassword: null,
        langCode: null,
        regNumber: null,
        clinic: null

      }
    }

  },
  created(){
    this.$bus.$on('language', () => {
      this.translation = window.message;
    });
    this.translation = window.message;
  },
  methods: {
    validateDoctor: function (e) {
      this.errors = [];
      if (!this.response.doctorEmail) {
        this.errors.push(
          this.translation.registration.field + ' "' +
          this.translation.registration.email + '" ' +
          this.translation.registration.required
        );
        this.requiredEmail = true;
      } else if (!this.validEmail(this.response.doctorEmail)) {
        this.errors.push(this.translation.registration.email);
        this.requiredEmail = true;
      }
      if (!this.response.doctorFirstName) {
        this.errors.push(
          this.translation.registration.field + ' "' +
          this.translation.registration.doctorFirstName + '" ' +
          this.translation.registration.required
        );
        this.requiredFirstName = true;
      }
      if (!this.response.doctorLastName) {
        this.errors.push(
          this.translation.registration.field + ' "' +
          this.translation.registration.doctorLastName + '" ' +
          this.translation.registration.required
        );
        this.requiredLastName = true;
      }
      if (!this.response.regNumber) {
        this.errors.push(
          this.translation.registration.field + ' "' +
          this.translation.registration.regNumber + '" ' +
          this.translation.registration.required
        );
        this.requiredRegNumber = true;
      }
      if (!this.response.clinic) {
        this.errors.push(
          this.translation.registration.field + ' "' +
          this.translation.registration.clinic + '" ' +
          this.translation.registration.required
        );
        this.requiredClinic = true;
      }
      if (!this.response.doctorPassword) {
        this.errors.push(
          this.translation.registration.field + ' "' +
          this.translation.registration.password + '" ' +
          this.translation.registration.required
        );
        this.requiredPassword = true;
      }else if (this.response.doctorPassword.length < 6) {
        this.errors.push(
          this.translation.registration.passwordLenthError
        );
        this.requiredPassword = true;
      }

      if (!this.errors.length) {
        return true;
      }

      e.preventDefault();
    },
    validEmail: function (doctorEmail) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(doctorEmail);
    },
    registretionDoctor: function (e){
      // Object.values(

      if (this.validateDoctor(e)) {
        this.loader = true;
        if (localStorage.getItem('language')) {
          this.response.langCode = localStorage.getItem('language');
        }else {
          this.response.langCode = 'bg_BG';
        }
        var formData = this.toFormData(this.response);
        var self = this;
        axios.post('doctor-registration', formData)
        .then(function(response){
          self.loader = false;
        if (response.data.success && response.data.result == null) {
            self.$bus.$emit('doctorLoggedIn', true)
            const time = new Date().getTime();
            var formData = self.toFormData({lastActive:time})
            axios.post('check-doctor-last-active',formData)
            .then(function(){})
            self.$router.push('/update-doctor-profile')
          }
          if (response.data.success && response.data.result.serverMessage) {
            var checkError = response.data.result.serverMessage;
            if (checkError == 'emptyEmail') {
              self.errors.push(self.translation.serverError.emptyEmail);
            }else if (checkError == 'invalidEmail') {
              self.errors.push(self.translation.serverError.invalidEmail);
            }else if (checkError == 'busyEmail') {
              self.errors.push(self.translation.serverError.busyEmail);
            }else if (checkError == 'invalidFirstName') {
              self.errors.push(self.translation.serverError.invalidFirstName);
            }else if (checkError == 'firstNameLengt') {
              self.errors.push(self.translation.serverError.firstNameLengt);
            }else if (checkError == 'firstNameSymbol') {
              self.errors.push(self.translation.serverError.firstNameSymbol);
            }else if (checkError == 'invalidLastName') {
              self.errors.push(self.translation.serverError.invalidLastName);
            }else if (checkError == 'LastNameLengt') {
              self.errors.push(self.translation.serverError.LastNameLengt);
            }else if (checkError == 'LastNameSymbol') {
              self.errors.push(self.translation.serverError.LastNameSymbol);
            }else if (checkError == 'validEmail') {
              self.errors.push(self.translation.serverError.validEmail);
            }else if (checkError == 'emptyPassword') {
              self.errors.push(self.translation.serverError.emptyPassword);
            }else if (checkError == 'passwordLengt') {
              self.errors.push(self.translation.serverError.passwordLengt);
            }else if (checkError == 'wrongEmail') {
              self.errors.push(self.translation.serverError.wrongEmail);
            }else if (checkError == 'wrongPassword') {
              self.errors.push(self.translation.serverError.wrongPassword);
            }else if (checkError == 'regNumberError') {
              self.errors.push(self.translation.serverError.regNumberError);
            }else if (checkError == 'clinicError') {
              self.errors.push(self.translation.serverError.clinicError);
            }
          }else {
            self.response = { doctorEmail, doctorFirstName,doctorLastName, doctorPassword,regNumber,clinic,langCode };
          }
        })
        .catch(err => err)
      }

    },
    showPassword() {
       if(this.type === "password") {
          this.type = "text";
       } else {
          this.type = "password";
       }
     },
    toFormData: function (obj){
      var form_data = new FormData();
      for (var key in obj) {
        form_data.append(key,obj[key]);
      }
      return form_data;
    }
  }

}
</script>

<style scoped>

</style>
